<!-- {{ videoUrl }} -->
<iframe *ngIf="isYouTube" #videoFrame width="100%" class="w-100 video-frame" [id]="frameId"
  [ngClass]="{ 'custom-thumbnail': customThumbnail }" [src]="videoUrl" [attr.data-src]="videoUrl" [title]="title"
  frameborder="0"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
  allowfullscreen="" data-gtm-yt-inspected-10="true"></iframe>

<video *ngIf="!isYouTube" #nativeVideo width="100%" class="w-100 video-frame"
  [ngClass]="{ 'custom-thumbnail': customThumbnail }" [src]="fileUrl" [title]="title" controls preload="metadata"
  playsinline></video>

<h2 class="heading" *ngIf="heading">{{ heading }}</h2>
<p class="description" *ngIf="description">{{ description }}</p>